import _slicedToArray from "/builds/9xb/sites/peracto3/jigsaw24services/jigsaw24.com/peracto.jigsaw24.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/builds/9xb/sites/peracto3/jigsaw24services/jigsaw24.com/peracto.jigsaw24.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "/builds/9xb/sites/peracto3/jigsaw24services/jigsaw24.com/peracto.jigsaw24.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { useEffect as s, useRef as f } from "react";
import { useEvent as i } from './use-event.js';

function m(u, t) {
  var e = f([]),
      r = i(u);
  s(function () {
    var o = _toConsumableArray(e.current);

    var _iterator = _createForOfIteratorHelper(t.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            n = _step$value[0],
            a = _step$value[1];

        if (e.current[n] !== a) {
          var l = r(t, o);
          return e.current = t, l;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }, [r].concat(_toConsumableArray(t)));
}

export { m as useWatch };